import {
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { Trade } from '../../models/trade';
import { Direction } from '../../models/direction';
import { SocketService } from '../../services/SocketService';
import { HttpClient } from '@angular/common/http';
import { StateService } from '../../services/state.service';
import { ConfigurationService } from '../../services';
import { DetailsExpandAnimation } from '../../directives/details-expand.directive';
import * as moment from 'moment';
import 'moment-timezone';
import { FirstCC, PriceFactorPipe, SecondCC } from '../../helpers/pipes';
import { UserService } from '../../services/user.service';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { Oco } from '../../models/oco.model';
import { DateService } from '../../services/date.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  getCurrencyMappingsSelector,
  getCurrencyPairsSelector,
  getIsSuperUserSelector,
  getOnBehalfUsersSelector,
  getSelectedOnBehalfUserSelector,
  getSpotPricesSelector,
  getTopOrdersSelector
} from '../../store/state/selectors/matchboard.selectors';
import { CurrencyDto } from '../../models/CurrencyDto';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { PriceService } from '../../services/price.service';
import { Json } from '../../models/Json';

@Component({
  selector: 'rl-trade-modal',
  templateUrl: './trade-modal.component.html',
  animations: [DetailsExpandAnimation]
})
export class TradeModalComponent implements OnInit, AfterViewInit, AfterContentInit, AfterViewChecked {

  @Output()
  tradeTypeChange: EventEmitter<string> = new EventEmitter<string>();

  Tenors = [];
  selectedTenorId: any;

  dropdownList = [];
  dropdownListBack = [];
  selectedItems = [];
  selectedItemsBack = [];
  dropdownSettings: any;
  trade: Trade;
  trade2: Trade;
  focusVar = false;
  public mask = [];
  public amask = [];
  public qmask = [];
  public rmask = [];
  numberValue = '';

  price: any;
  amount: number;

  showPlusButton = false;
  Math: any;

  counterPartyUsers: any[];

  selectedCounterPartyId: string;

  public shouldRotate = true;
  // @ViewChild('myLabel') lab;
  @ViewChild('myLabel') lab: ElementRef;

  @ViewChild('multiSelectFront') multiSelectFront: AngularMultiSelect;

  @ViewChild('multiSelectBack') multiSelectBack: AngularMultiSelect;

  front = true;

  detailStatus: boolean = false;

  sliderValue: any;
  swapRate: any;

  Slider: any;
  @Input() name: string;

  todayDate = new Date();
  tradeDate: any;

  localDate = moment(this.todayDate).tz('America/New_York').format('DD MMM.');

  nearLegDate: any;
  // tradeValueDate: Moment;

  isSuperUser: boolean;

  previousSessionDate: boolean;

  swapPriceFactor: number;

  isOcoActive: boolean = false;
  isOcoActiveBack: boolean = false;

  ocos: Oco[] = [];

  ocosBack: Oco[] = [];

  rangeSliderMaxPrice: number;
  rangeSliderMinPrice: number;
  rangeSliderPrice: number;

  rangeSliderMaxPriceBack: number;
  rangeSliderMinPriceBack: number;
  rangeSliderPriceBack: number;

  selectedOrderIndex: number;
  selectedOrderIndexBack: number;
  daysDifferenceBtwNearlegAndFarlegDate: number;

  currencyPairData: CurrencyDto;
  currencyPairs: CurrencyDto[];
  currencyPairsJson: Json<string, CurrencyDto>;

  selectedOnBehalfUser: string;

  currencyMappings: any;
  spotPrices: any;

  topOrders: any;

  changeDirection(): void {
    if (this.trade.direction === Direction.LEND) {
      this.trade.direction = Direction.BORROW;
    } else {
      this.trade.direction = Direction.LEND;
    }
  }

  constructor(
    protected bsModalRef: BsModalRef,
    private translate: TranslateService,
    protected socketService: SocketService,
    private httpClient: HttpClient,
    protected stateService: StateService,
    private configurationService: ConfigurationService,
    private renderer: Renderer2,
    protected priceFactorPipe: PriceFactorPipe,
    private userService: UserService,
    protected firstCC: FirstCC,
    protected secondCC: SecondCC,
    private dateService: DateService,
    private readonly store: Store<MatchBoardState>,
    private readonly priceService: PriceService,
    private cdr: ChangeDetectorRef
  ) {
    this.Math = Math;
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   if (this.trade.from === 'borrowSideAmount' || this.trade.from === 'lendSideAmount' || this.trade.from === 'lendSideQuantity' || this.trade.from === 'borrowSideQuantity') {
    //     this.flipModal();
    //   }
    // }, 1);
  }

  ngAfterViewChecked(): void {
    // TODO why???
    // this.cdr.detectChanges();
  }

  getCurrentMarket() {
    // return this.stateService.getSpotPriceForCurrencyPair(this.trade.sixLetterCode);
    return this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.trade.sixLetterCode);
  }

  getFormattedSpotPrice(decimal: boolean) {
    const precision = this.configurationService.getSpotDecimalPrecisionForCurrencyPair(this.trade.sixLetterCode);
    if (decimal && precision === 0) {
      return null;
    }

    const formattedSpotPrice = (this.getCurrentMarket() * this.currencyPairData.spotPriceFactor).toFixed(this.currencyPairData.displaySpotPricePrecision);

    if (!decimal) {
      return Math.floor(Number(formattedSpotPrice));
    }
    return formattedSpotPrice.split('.')[1];
  }

  close() {
    this.bsModalRef.hide();
    this.renderer.removeClass(document.body, 'modal-open');
  }

  showDetails() {
    this.detailStatus = !this.detailStatus;
  }


  flipModal() {
    this.front = false;
    this.invertPrice();
    this.initBackSideRangeSlider();
    this.setBaseOrderToRangeSliderBack();
    if (this.detailStatus === false)  {
      this.bsModalRef.setClass('modal-trade modal-lg rotateY');
      setTimeout(() => {
        this.showDetails();
      }, 1000);
    } else {
      this.bsModalRef.setClass('modal-trade modal-lg rotateY');
    }
  }

  flipModalBack() {
    this.front = true;
    this.invertPrice();
    if (this.detailStatus === true) {
      this.showDetails();
      this.bsModalRef.setClass('modal-trade modal-lg rotateYback');
    } else {
      this.bsModalRef.setClass('modal-trade modal-lg rotateYback');
    }
  }

  invertPrice() {
    if (this.price === '-_') {
      this.price = 0;
    } else {
      this.price = this.getMaskedPriceAsNumber() * -1;
    }
  }

  setBaseOrderToRangeSlider() {
    this.selectedOrderIndex = -1;
    this.rangeSliderMaxPrice = this.trade.priceAsk > this.trade.priceBid ? this.trade.priceAsk : this.trade.priceBid;
    this.rangeSliderMinPrice = this.trade.priceAsk < this.trade.priceBid ? this.trade.priceAsk : this.trade.priceBid;
    this.rangeSliderPrice = this.getMaskedPriceAsNumber();
  }

  initBackSideRangeSlider() {
    // swap the two price (min, max)
    this.rangeSliderMaxPriceBack = this.rangeSliderMinPrice * -1;
    this.rangeSliderMinPriceBack = this.rangeSliderMaxPrice * -1;
  }

  setBaseOrderToRangeSliderBack() {
    this.selectedOrderIndexBack = -1;
    this.rangeSliderPriceBack = this.getMaskedPriceAsNumber();
  }

  getNumberMask(sixLetterCode: string) {
    return createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: sixLetterCode.includes('JPY') ? 0 : 2,
      decimalSymbol: sixLetterCode.includes('JPY') ? '' : '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: true,
      integerLimit: 13,
    });
  }

  ngOnInit() {
    this.store.select(getSelectedOnBehalfUserSelector).subscribe((selectedUser) => {
      this.selectedOnBehalfUser = selectedUser;
    });

    this.store.select(getIsSuperUserSelector).subscribe((isSuperUser) => {
      this.isSuperUser = isSuperUser;
    });

    let userId: string;
    if (this.isSuperUser) {
      userId = this.selectedOnBehalfUser;
    } else {
      userId = this.userService.getUser().id;
    }

    this.store.select(getTopOrdersSelector).subscribe((topOrders) => {
      this.topOrders = topOrders;
    });

    this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairs = currencyPairs;
      this.currencyPairsJson = new Json(currencyPairs, 'sixLetterCode');
    });

    this.store.select(getOnBehalfUsersSelector).subscribe((onBehalfUsers) => {
      this.counterPartyUsers = onBehalfUsers
        .filter(u => u.id !== userId);
    });

    this.store.select(getCurrencyMappingsSelector).subscribe((currencyMappings) => {
      this.currencyMappings = currencyMappings;
    });

    this.store.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    });

    // this.counterPartyUsers = this.stateService.getOnBehalfUsers()
    //   .filter(u => u.id !== userId);
    this.currencyPairData = this.currencyPairs.find(cp => cp.sixLetterCode === this.trade.sixLetterCode);
    this.mask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: Math.max((this.currencyPairData.swapPricePrecision - Math.log10(this.currencyPairData.swapPriceFactor)), 0),
      decimalSymbol: this.currencyPairData.swapPricePrecision !== 0 ? '.' : '',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: true,
      integerLimit: 13,
    });
    this.rmask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 2,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: true,
      integerLimit: 7,
    });

    this.amask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: this.currencyPairData.swapPricePrecision,
      decimalSymbol: this.currencyPairData.swapPricePrecision !== 0 ? '.' : '',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: false,
      integerLimit: 13,
    });

    this.qmask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: this.currencyPairData.swapPricePrecision,
      decimalSymbol: this.currencyPairData.swapPricePrecision !== 0 ? '.' : '',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: false,
      integerLimit: 13,
    });

    this.trade2 = new Trade(
      this.trade.orderId,
      this.trade.sixLetterCode,
      this.trade.quantity,
      this.priceFactorPipe.transform(this.trade.priceBid * -1, this.trade.sixLetterCode),
      this.priceFactorPipe.transform(this.trade.priceAsk * -1, this.trade.sixLetterCode),
      this.trade.currentMarket,
      this.trade.amount,
      this.trade.from,
      this.trade.direction);
    this.userService.isSuperUser() ? this.isSuperUser = true : this.isSuperUser = false;
    this.Tenors = [
      {id: 1, name: 'O/N', value: 'ON'},
      {id: 2, name: 'Ti', value: 'TI'},
      {id: 3, name: 'TOD-TOM', value: 'TOD_TOM'},
      {id: 4, name: '1w', value: 'W1'},
      {id: 5, name: '2w', value: 'W2'}
    ];

    this.dropdownList = [];

    this.currencyPairs.forEach(curr => {
      if (curr.sixLetterCode.includes(this.firstCC.transform(this.trade.sixLetterCode)) && this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, curr.sixLetterCode) != null) {
        if (this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, curr.sixLetterCode) && this.secondCC.transform(curr.sixLetterCode) !== this.firstCC.transform(this.trade.sixLetterCode)) {
          this.dropdownListBack.push({id: this.dropdownListBack.length, ccy: curr.sixLetterCode.replace(this.firstCC.transform(this.trade.sixLetterCode), ''), itemName: curr.instrument.termCcy});
        }
      }
      if (curr.sixLetterCode.includes(this.secondCC.transform(this.trade.sixLetterCode)) && this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, curr.sixLetterCode) != null) {
        if (this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, curr.sixLetterCode)) {
          this.dropdownList.push({id: this.dropdownList.length, ccy: curr.sixLetterCode.replace(this.secondCC.transform(this.trade.sixLetterCode), ''), itemName: curr.instrument.baseCcy});
        }
      }

    });

    this.selectedItems = [
      this.dropdownList.find(item => item.ccy === this.firstCC.transform(this.trade.sixLetterCode))
    ];
    this.selectedItemsBack = [
      this.dropdownListBack.find(item => item.ccy === this.secondCC.transform(this.trade.sixLetterCode))
    ];

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select',
      enableCheckAll: false,
      enableSearchFilter: true,
      searchPlaceholderText: '',
      classes: 'myclass custom-class',
      disabled: false
    };

    if (!this['order']) {
      if (this.trade.direction === 'LEND') {
        if (this.trade.sixLetterCode.includes('JPY')) {
          this.price = Number(this.priceFactorPipe.transform(this.trade.priceBid, this.trade.sixLetterCode).toFixed(0));
        } else {
          this.price = Number(this.priceFactorPipe.transform(this.trade.priceBid, this.trade.sixLetterCode).toFixed(2));
        }

      } else {
        if (this.trade.sixLetterCode.includes('JPY')) {
          this.price = Number(this.priceFactorPipe.transform(this.trade.priceAsk, this.trade.sixLetterCode).toFixed(0));
        } else {
          this.price = Number(this.priceFactorPipe.transform(this.trade.priceAsk, this.trade.sixLetterCode).toFixed(2));
        }
      }
    }

    if (this.trade.from === 'placeAnOrder') {
      if (this.trade.sixLetterCode.includes('JPY')) {
        this.price = Number(this.priceFactorPipe.transform(this.trade.priceAsk, this.trade.sixLetterCode).toFixed(0));
      } else {
        this.price = Number(this.priceFactorPipe.transform(this.trade.priceAsk, this.trade.sixLetterCode).toFixed(2));
      }
    }

    this.trade.priceAsk = this.priceFactorPipe.transform(this.trade.priceAsk, this.trade.sixLetterCode);
    this.trade.priceBid = this.priceFactorPipe.transform(this.trade.priceBid, this.trade.sixLetterCode);

    this.setBaseOrderToRangeSlider();

    this.swapPriceFactor = this.getCpFactor();

    this.calculateAmount();

    this.previousSessionDate = this.userService.isSuperUser();
    this.nearLegDate = this.previousSessionDate ? this.dateService.getNearLegDateOnPreviousSessionDate(this.selectedTenorId) : this.dateService.getNearLegDate(this.selectedTenorId);
    this.daysDifferenceBtwNearlegAndFarlegDate = this.getDayDifferenceBtwFarLegDateAndNearLegDate(this.selectedTenorId);
    this.changeSwapRate(null, 'INPUT');
    // this.tradeValueDate = this.getTradeValueDate();
  }

  onItemSelect(item: any) {
    const toAddOco = new Oco(item.ccy + this.secondCC.transform(this.trade.sixLetterCode), null, null, this.swapRate);
    this.changeOcoSwapPrice(toAddOco);
    this.calculateQuantityToOcoOrder(toAddOco);
    this.ocos.push(toAddOco);
  }

  onItemSelectBack(item: any) {
    const toAddOco = new Oco(this.firstCC.transform(this.trade.sixLetterCode) + item.ccy, null, null, this.swapRate);
    this.changeOcoSwapPrice(toAddOco);
    this.calculateQuantityToOcoOrder(toAddOco);
    this.ocosBack.push(toAddOco);
    this.calculateAmount();
  }

  OnItemDeSelect(item: any) {
    this.ocos = this.ocos.filter(o => o.sixLetterCode !== (item.ccy + this.secondCC.transform(this.trade.sixLetterCode)));
  }

  OnItemDeSelectBack(item: any) {
    this.ocosBack = this.ocosBack.filter(o => o.sixLetterCode !== (this.firstCC.transform(this.trade.sixLetterCode) + item.ccy));
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onDeSelectAll(item: any) {
    console.log(item);
  }

  getSecondCC(sixLetterCode: string) {
    return sixLetterCode.substring(0, 3);
  }

  getFirstCC(sixLetterCode: string) {
    return sixLetterCode.substring(3, 6);
  }

  // Auto focus input field
  inputFocus() {
    document.getElementById('quantity').focus();
  }

  inputFocusTimed() {
    setTimeout(() => {
      this.inputFocus();
    }, 100);
  }

  ngAfterContentInit() {
    this.inputFocusTimed();
  }

  // showPlusButton(evt) {
  //   console.log('aaaaaa', evt);
  //   let element = document.getElementById('plusButton');
  //   element.className = 'd-block'
  // }

  validateTradeKeyPress(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.key;

    this.numberValue = evt.target.value;
    this.showPlusButton = true;
    // console.log('aaaaaaaaa', this.showPlusButton);

    // Set plus
    // if (this.numberValue[0] === '-') {
    //   this.inputPrefix = '-'
    // } else {
    //   this.inputPrefix = '+'
    // }

    // Prevent to write zero in lead
    if (this.numberValue[0] === '0') {
      evt.target.value = this.numberValue.replace(/^([1-9][0-9]*)|([0]+)$/, '');
    }

    // . character
    if (charCode === 190) {
      evt.target.value = this.numberValue.replace('_', '');
    }

    // M character
    if (charCode === 77) {
      let countM = this.numberValue.replace(/,/g, '');
      countM = (parseFloat(countM) * 1000000).toString();
      evt.target.value = countM;
    }

    // K character
    if (charCode === 75) {
      let countK = this.numberValue.replace(/,/g, '');
      countK = (parseFloat(countK) * 1000).toString();
      evt.target.value = countK;
    }
  }

  keyUpEnter(event) {
    const charCode = (event.which) ? event.which : event.key;
    if (charCode === 13) {
      if (this.front) {
        this.sendOrder();
      } else {
        this.sendInvertedOrder();
      }
    }
  }

  sendOrder() {
    if (this.isOcoActive) {
      this.socketService.send('addOrder', {
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(), this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.trade.direction,
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
        ocos: this.ocos.map(item => {
          return {
            sixLetterCode: item.sixLetterCode,
            swapPrice: Number(this.priceFactorPipe.transform(item.swapPrice, item.sixLetterCode, true).toFixed(8))
          };
        }),
        counterPartyId: this.selectedCounterPartyId
      });
    } else {
      this.socketService.send('addOrder', {
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(), this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.trade.direction,
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
        ocos: [],
        counterPartyId: this.selectedCounterPartyId
      });
      this.ocos.forEach(o => {
        // const sixLetterCode = this.getSixLetterCode(o.sixLetterCode);
        const sixLetterCode = o.sixLetterCode;
        if (sixLetterCode) {
          this.socketService.send('addOrder', {
            sixLetterCode: o.sixLetterCode,
            tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
            swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(o.swapPrice), o.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
            quantity: this.getMaskedPriceAsNumber(o.quantity),
            direction: this.trade.direction,
            placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
            previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
            tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
            isInverted: false,
            ocos: [],
            counterPartyId: this.selectedCounterPartyId
          });
        }
      });
    }
    this.bsModalRef.hide();
  }

  sendInvertedOrder() {
    if (this.isOcoActiveBack) {
      this.socketService.send('addOrder', {
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(Number(this.getMaskedPriceAsNumber()) * -1, this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.getOppositeDirection(this.trade.direction),
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
        ocos: this.isOcoActiveBack ? this.ocosBack.map(item => {
          return {
            sixLetterCode: item.sixLetterCode,
            swapPrice: Number(this.priceFactorPipe.transform(item.swapPrice, item.sixLetterCode, true).toFixed(8)) * -1
          };
        }) : [],
        counterPartyId: this.selectedCounterPartyId
      });
    } else {
      this.socketService.send('addOrder', {
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(Number(this.getMaskedPriceAsNumber()) * -1, this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.getOppositeDirection(this.trade.direction),
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
        ocos: [],
        counterPartyId: this.selectedCounterPartyId
      });
      this.ocosBack.forEach(o => {
        this.socketService.send('addOrder', {
          sixLetterCode: o.sixLetterCode,
          tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
          swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(o.swapPrice), o.sixLetterCode, true) * -1).toFixed(this.currencyPairData.swapPricePrecision)),
          quantity: this.getMaskedPriceAsNumber(o.quantity),
          direction: this.getOppositeDirection(this.trade.direction),
          placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
          previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
          tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
          ocos: [],
          counterPartyId: this.selectedCounterPartyId
        });
      });
    }

    this.bsModalRef.hide();
  }

  getOppositeDirection(direction) {
    if (direction === 'LEND') {
      return 'BORROW';
    }
    return 'LEND';
  }

  getQuantity() {
    return this.trade.amount / this.getCurrentMarket();
  }

  changeSwapRate(event, from: string, selectedTenor = this.selectedTenorId) {
    if (this.price === '-_' || (typeof this.price === 'string' && this.price.slice(-1) === '.')) {
      return;
    }
    if (this.front && event !== this.rangeSliderPrice) {
      if (from === 'SLIDER') {
        if (this.selectedOrderIndex === -1) {
          this.price = this.getMaskedPriceAsNumber(this.rangeSliderPrice);
          this.swapRate = (this.getDaysDividerToSwapRateByTradeType(selectedTenor) * (Number(this.getMaskedPriceAsNumber()) / this.getCpFactor())) / this.trade.currentMarket * 100;
          this.swapRate = Number(this.swapRate.toFixed(2));
          this.calculateAmount();
          this.setSwapRateToOcos();
        } else {
          this.ocos[this.selectedOrderIndex].swapPrice = this.getMaskedPriceAsNumber(this.rangeSliderPrice);
          this.changeOcoSwapRate(this.ocos[this.selectedOrderIndex]);
          this.calculateQuantityToOcoOrder(this.ocos[this.selectedOrderIndex]);
        }
      } else if (from === 'INPUT') {
        if (this.selectedOrderIndex === -1) {
          this.rangeSliderPrice = this.getMaskedPriceAsNumber();
          this.swapRate = (this.getDaysDividerToSwapRateByTradeType(selectedTenor) * (Number(this.getMaskedPriceAsNumber()) / this.getCpFactor())) / this.trade.currentMarket * 100;
          this.swapRate = Number(this.swapRate.toFixed(2));
          this.calculateAmount();
          this.setSwapRateToOcos();
        } else {
          this.rangeSliderPrice = this.getMaskedPriceAsNumber(this.ocos[this.selectedOrderIndex].swapPrice);
          this.changeOcoSwapRate(this.ocos[this.selectedOrderIndex]);
          this.calculateQuantityToOcoOrder(this.ocos[this.selectedOrderIndex]);
        }
      } else if (from === 'AMOUNT') {
        this.swapRate = (this.getDaysDividerToSwapRateByTradeType(selectedTenor) * (Number(this.getMaskedPriceAsNumber()) / this.getCpFactor())) / this.trade.currentMarket * 100;
        this.swapRate = Number(this.swapRate.toFixed(2));
        this.setSwapRateToOcos();
      }
    } else if (!this.front && event !== this.rangeSliderPriceBack) {
      if (from === 'SLIDER') {
        if (this.selectedOrderIndexBack === -1) {
          this.price = this.getMaskedPriceAsNumber(this.rangeSliderPriceBack);
          this.swapRate = (this.getDaysDividerToSwapRateByTradeType(selectedTenor) * (Number(this.getMaskedPriceAsNumber()) / this.getCpFactor())) / this.trade.currentMarket * 100;
          this.swapRate = Number(this.swapRate.toFixed(2));
          this.calculateAmount();
          this.setSwapRateToOcos();
        } else {
          this.ocosBack[this.selectedOrderIndexBack].swapPrice = this.getMaskedPriceAsNumber(this.rangeSliderPriceBack);
          this.changeOcoSwapRate(this.ocosBack[this.selectedOrderIndexBack]);
          this.calculateQuantityToOcoOrder(this.ocosBack[this.selectedOrderIndexBack]);
          this.calculateAmountForOcoOrder(this.ocosBack[this.selectedOrderIndexBack]);
        }
      } else if (from === 'INPUT') {
        if (this.selectedOrderIndexBack === -1) {
          this.rangeSliderPriceBack = this.getMaskedPriceAsNumber();
          this.swapRate = (this.getDaysDividerToSwapRateByTradeType(selectedTenor) * (Number(this.getMaskedPriceAsNumber()) / this.getCpFactor())) / this.trade.currentMarket * 100;
          this.swapRate = Number(this.swapRate.toFixed(2));
          this.calculateAmount();
          this.setSwapRateToOcos();
        } else {
          this.rangeSliderPriceBack = this.getMaskedPriceAsNumber(this.ocosBack[this.selectedOrderIndexBack].swapPrice);
          this.changeOcoSwapRate(this.ocosBack[this.selectedOrderIndexBack]);
          this.calculateQuantityToOcoOrder(this.ocosBack[this.selectedOrderIndexBack]);
        }
      }
    }

  }

  setSwapRateToOcos() {
    if (this.front) {
      for (const oco of this.ocos) {
        oco.swapRate = this.swapRate;
        this.changeOcoSwapPrice(oco);
      }
    } else {
      for (const oco of this.ocosBack) {
        oco.swapRate = this.swapRate;
        this.changeOcoSwapPrice(oco);
      }
    }

  }

  changeOcoSwapRate(oco: Oco) {
    if (oco.swapPrice === '-_') {
      return;
    }
    oco.swapRate = Number(((this.getDaysDividerToSwapRateByTradeType(this.selectedTenorId) * (this.getMaskedPriceAsNumber(oco.swapPrice) / this.getCpFactor(oco.sixLetterCode))) / this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, oco.sixLetterCode) * 100).toFixed(2));
  }

  changeOcoSwapPrice(oco: Oco) {
    if (oco.swapRate === '-') {
      return;
    }
    oco.swapPrice = Number((Number(((oco.swapRate * this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, oco.sixLetterCode)) / (this.getDaysDividerToSwapRateByTradeType(this.selectedTenorId) * 100)) * this.getCpFactor(oco.sixLetterCode))).toFixed(2));
    if (oco.sixLetterCode.includes('JPY')) {
      oco.swapPrice = Math.round(oco.swapPrice);
      this.changeOcoSwapRate(oco);
    }
  }

  getDaysDividerToSwapRateByTradeType(swapType) {
    if (swapType === 'ON' || swapType.toUpperCase() === 'TI') {
      if (this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType) === 1) {
        return 365;
      } else {
        return 365 / this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType);
      }
    }
    if (swapType === 'TOD_TOM') {
      return 365;
    }
    if (swapType === 'W1') {
      return 52;
    }

    return 26;
  }

  getDayDifferenceBtwFarLegDateAndNearLegDate(tradeType): number {
    const nearLegDate = this.previousSessionDate ? this.dateService.getNearLegDateOnPreviousSessionDate(this.selectedTenorId) : this.dateService.getNearLegDate(this.selectedTenorId);
    const copy = moment(nearLegDate);
    const farLegDate = this.dateService.getTradeValueDate(copy, tradeType);
    const duration = moment.duration(farLegDate.diff(nearLegDate));
    return duration.asDays();
  }

  getCpFactor(sixLetterCode = this.trade.sixLetterCode) {
    // TODO check
    // return this.currencyPairData.swapPriceFactor;
    const cu = this.currencyPairs.find(cp => cp.sixLetterCode === sixLetterCode);
    if (!cu) {
      return 1;
    }
    return cu.swapPriceFactor;
  }

  changePrice() {
    if (this.swapRate === '-' || (typeof this.swapRate === 'string' && this.swapRate.slice(-1) === '.')) {
      return;
    }
    // if (typeof this.swapRate === 'string' && this.swapRate.match(/./g).length > 1) {
    //   this.swapRate = this.swapRate.slice(0, -1);
    //   return;
    // }
    if (isNaN(+this.swapRate)) {
      return;
    }

    this.price = Number(((this.getMaskedPriceAsNumber(this.swapRate) * this.trade.currentMarket) / (this.getDaysDividerToSwapRateByTradeType(this.selectedTenorId) * 100)) * this.getCpFactor());
    if (this.trade.sixLetterCode.includes('JPY')) {
      this.price = Number(this.price.toFixed(0));
    } else {
      this.price = Number(this.price.toFixed(2));
    }
    if (this.front) {
      this.rangeSliderPrice = this.getMaskedPriceAsNumber();
    } else {
      this.rangeSliderPriceBack = this.getMaskedPriceAsNumber();
    }
    this.calculateAmount();
    this.setSwapRateToOcos();
  }

  calculateAmount() {
    this.amount = Math.abs(Number((this.getMaskedPriceAsNumber(this.trade.quantity) * (this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.trade.sixLetterCode) + this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(this.price), this.trade.sixLetterCode, true))).toFixed(this.configurationService.getSpotDecimalPrecisionForCurrencyPair(this.trade.sixLetterCode))));
    if (this.front) {
      for (const oco of this.ocos) {
        this.calculateQuantityToOcoOrder(oco);
      }
    } else {
      for (const oco of this.ocosBack) {
        oco.amount = Number((this.getMaskedPriceAsNumber(this.trade.quantity) * (oco.swapPrice + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, oco.sixLetterCode))).toFixed(2));
      }
    }
  }

  calculateAmountForOcoOrder(oco: Oco) {
    oco.amount = Number((this.getMaskedPriceAsNumber(this.trade.quantity) * (this.priceFactorPipe.transform(oco.swapPrice, oco.sixLetterCode, true) + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, oco.sixLetterCode))).toFixed(2));
  }

  // calculateAmountBack() {
  //   for (const oco of this.ocosBack) {
  //     oco.amount = this.trade.quantity * this.stateService.getSpotPriceForCurrencyPair(oco.sixLetterCode);
  //   }
  // }

  calculateQuantityToOcoOrder(oco: Oco): void {
    oco.quantity = Number((this.amount / (oco.swapPrice + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, oco.sixLetterCode))).toFixed(2));
  }

  calculateQuantityByAmount(amountInString: string) {
    const amount = this.getMaskedPriceAsNumber(amountInString);
    if (this.front) {
      this.trade.quantity = Number((amount / (this.getMaskedPriceAsNumber() + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.trade.sixLetterCode))).toFixed(2));
    } else {
      this.trade2.quantity = Number((amount / (this.getMaskedPriceAsNumber() + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.trade.sixLetterCode))).toFixed(2));
    }
    this.changeSwapRate(null, 'AMOUNT');
  }

  getDateForSecondColumn() {
    const tenor = this.Tenors.filter(t => t.value === this.selectedTenorId)[0];
    const commonWeekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU'];

    if (tenor.name === '1w') {
      return this.getDatePlus(7);
    }
    if (tenor.name === '2w') {
      return this.getDatePlus(14);

    }

    const todayAsWeekday = moment(new Date()).tz('America/New_York').format('ddd').toUpperCase();
    if (tenor.name === 'O/N') {
      if (commonWeekDays.includes(todayAsWeekday)) {
        return this.getDatePlus(1);
      }
      if (todayAsWeekday === 'SAT') {
        return this.getDatePlus(2);
      }
      if (todayAsWeekday === 'FRI') {
        return this.getDatePlus(3);
      }
    }
    if (tenor.name === 'TOD-TOM') {
      if (commonWeekDays.includes(todayAsWeekday)) {
        return this.getDatePlus(1);
      }
      if (todayAsWeekday === 'FRI') {
        return this.getDatePlus(3);
      }
    }

    throw new Error();
  }

  getTradeValueDate(): any {
    const tenor = this.Tenors.filter(t => t.value === this.selectedTenorId)[0];
    const copy = moment(this.nearLegDate);
    return this.dateService.getTradeValueDate(copy, tenor.value);
  }

  getDatePlus(plusDay: number) {
    const today = moment(new Date()).tz('America/New_York');
    let afterFivePlusDay = 0;

    if (today.hour() > 17) {
      afterFivePlusDay++;
    }
    if (afterFivePlusDay > 0 && moment(new Date()).tz('America/New_York').format('ddd')) {
      afterFivePlusDay = 4;
    }

    return today.add(plusDay + afterFivePlusDay, 'days').format('DD MMM.');
  }

  getMaskedPriceAsNumber(price = this.price) {
    if (typeof price === 'string') {
      return Number(price.split(',').join(''));
    }
    return Number(price);
  }

  reloadDropdownSettings(back: boolean = false) {
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   text: 'Select',
    //   enableCheckAll: false,
    //   enableSearchFilter: true,
    //   searchPlaceholderText: '',
    //   classes: 'myclass custom-class',
    //   disabled: back ? !this.isOcoActiveBack : !this.isOcoActive
    // };

    this.openModal(back);
  }

  filterBaseCurrency() {
    this.multiSelectFront.data = this.multiSelectFront.data.filter(item => item.ccy !== this.firstCC.transform(this.trade.sixLetterCode));
  }

  filterBaseCurrencyOnBackSide() {
    this.multiSelectBack.data = this.multiSelectBack.data.filter(item => item.ccy !== this.secondCC.transform(this.trade.sixLetterCode));
  }

  setOcoToRangeSlider(oco: Oco) {
    const borrowPrice = this.getTopPriceForCurrAtDirection(oco.sixLetterCode, Direction.BORROW);
    const lendPrice = this.getTopPriceForCurrAtDirection(oco.sixLetterCode, Direction.LEND);
    this.selectedOrderIndex = this.ocos.findIndex(o => o === oco);
    this.rangeSliderPrice = this.getMaskedPriceAsNumber(oco.swapPrice);
    this.rangeSliderMinPrice = borrowPrice < lendPrice ? borrowPrice : lendPrice;
    this.rangeSliderMaxPrice = lendPrice > borrowPrice ? lendPrice : borrowPrice;
  }

  setOcoToRangeSliderBack(oco: Oco) {
    const borrowPrice = this.getTopPriceForCurrAtDirection(oco.sixLetterCode, Direction.BORROW);
    const lendPrice = this.getTopPriceForCurrAtDirection(oco.sixLetterCode, Direction.LEND);
    this.selectedOrderIndexBack = this.ocosBack.findIndex(o => o === oco);
    this.rangeSliderPriceBack = this.getMaskedPriceAsNumber(oco.swapPrice);
    this.rangeSliderMinPriceBack = borrowPrice < lendPrice ? borrowPrice : lendPrice;
    this.rangeSliderMaxPriceBack = lendPrice > borrowPrice ? lendPrice : borrowPrice;
  }

  getTopPriceForCurrAtDirection(sixLetterCode: string, direction: Direction) {
    // const pricesMap = this.stateService.getTopOrdersForCurrencyPair(sixLetterCode);
    const pricesMap = this.topOrders[sixLetterCode];
    if (!pricesMap) {
      return 0;
    }
    const prices = pricesMap[direction];
    if (!prices) {
      return 0;
    }
    return this.priceFactorPipe.transform(prices[0].price, sixLetterCode);
  }

  openModal(back: boolean) {
    if (back) {
      setTimeout(() => this.multiSelectBack.openDropdown(), 5);
    } else {
      setTimeout(() => this.multiSelectFront.openDropdown(), 5);
    }
  }

  changeDates() {
    if (this.previousSessionDate) {
      this.nearLegDate = this.dateService.getNearLegDateOnPreviousSessionDate(this.selectedTenorId);
    } else {
      this.nearLegDate = this.dateService.getNearLegDate(this.selectedTenorId);
    }
    this.daysDifferenceBtwNearlegAndFarlegDate = this.getDayDifferenceBtwFarLegDateAndNearLegDate(this.selectedTenorId);
    this.changeSwapRate(null, 'INPUT');
  }

  selectEvent(event: any) {
    event.target.select();
  }
}
